import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-offcanvas',
    imports: [RouterLink],
    templateUrl: './offcanvas.component.html',
    styleUrl: './offcanvas.component.scss'
})
export class OffcanvasComponent {

}
